import { Style } from '@solidjs/meta';

export function Veneer()
{
	return (
		<Style>{`@font-face {
    font-family: "Veneer Regular";
    src: url("https://db.onlinewebfonts.com/t/294f2e27fd0602c32be5a6d86f3f0b6e.eot");
    src: url("https://db.onlinewebfonts.com/t/294f2e27fd0602c32be5a6d86f3f0b6e.eot?#iefix")format("embedded-opentype"),
    url("https://db.onlinewebfonts.com/t/294f2e27fd0602c32be5a6d86f3f0b6e.woff2")format("woff2"),
    url("https://db.onlinewebfonts.com/t/294f2e27fd0602c32be5a6d86f3f0b6e.woff")format("woff"),
    url("https://db.onlinewebfonts.com/t/294f2e27fd0602c32be5a6d86f3f0b6e.ttf")format("truetype"),
    url("https://db.onlinewebfonts.com/t/294f2e27fd0602c32be5a6d86f3f0b6e.svg#Veneer Regular")format("svg");
}`}</Style>
	);
}

